import React, { FunctionComponent, MouseEvent } from 'react';
import cn from "classnames";

import './Button.scss';

interface IButtonProps {
    className?: string;
    disabled?: boolean;
    onClick?: (e?: MouseEvent) => void;
    theme?: 'red' | 'blue' | 'text';
    type?: 'button' | 'submit';
    dataCy?: string;
}

export const Button: FunctionComponent<IButtonProps> = function(props) {
    const theme = props.theme || 'red';
    const type = props.type || 'button';

    const classNames = cn(props.className, {
        cfa_button: true,
        red: theme === 'red',
        blue: theme === 'blue',
        text: theme === 'text',
        disabled: props.disabled,
    })

    const onClick = (e: MouseEvent) => {
        if (props.disabled) {
            // Needed to prevent form submit for forms.
            e.preventDefault();
        } else if (props.onClick) {
            props.onClick(e);
        }
    }

    return (
        <button className={classNames} onClick={onClick} type={type}>
            {props.children}
        </button>
    );
}